<template>
    <div
        id="logo_image_background"
        class="h-screen vx-row no-gutter items-center justify-center authorization_background"

    >
<!--        :style="{'background': `url(${authorization_background})`, 'overflow-y': 'auto'}"-->
        <router-view></router-view>
    </div>
</template>

<script>
import utils from '@/assets/utils/index'
export default {
    name: "Cascade",
    data() {
        return {

        }
    },
    created() {
        this.getLogoImagePath()
    },
    methods: {
        async getLogoImagePath(){
            /*
            По неясным причинам у <div> в style получалось такое "background:  url('null')".
            Заработало как надо когда попробовал element.setAttribute()
             */
            const image_data = await utils.fetchLogoImage()
            if (image_data.message && image_data.message === 'logo_image_not_found' ) {
                let element = document.getElementById("logo_image_background") ;
                element.setAttribute('style',  `background: url('${ require('@/assets/images/pages/authorization-background.jpg') }'); overflow-y: auto;`  )
            } else {
                let element = document.getElementById("logo_image_background") ;
                element.setAttribute('style',  `background: url('${ image_data.path }'); overflow-y: auto;`  )

            }

        }
    }
}
</script>

<style scoped lang="scss">
.authorization_background{
    background-size: cover !important;

    &::v-deep {
        .form-button {
            @media screen and (max-width: 600px){
                width: 100%;
                margin-bottom: 10px;
                display: block;
            }
        }
    }
}
</style>
